// extracted by mini-css-extract-plugin
export default {"slot":"mobile-preview-toggle_slot__Wybgo","toggle":"mobile-preview-toggle_toggle__cedOE"};